import {
  getUserPlaylistDefault,
  deleteUserPlaylistDefaultCourse,
  createUserPlaylistDefaultCourse,
} from '@/api/playlist.api'

const state = {
  userPlaylistDefault: {}
}

const getters = {
  userPlaylistDefault ({ userPlaylistDefault }) {
    return userPlaylistDefault
  },

  userPlaylistDefaultCourses ({ userPlaylistDefault }) {
    return userPlaylistDefault.id
      ? userPlaylistDefault.playlist_courses
      : []
  },

  playlistDefaultCourseByCourseId ({ userPlaylistDefault }) {
    return (courseId) => {
      if (!userPlaylistDefault.id) {
        return null
      }
      
      return userPlaylistDefault.playlist_courses
        .find(i => i.course_id == courseId)
    }
  }
}

const mutations = {
  removeUserPlaylistDefaultCourse (state, playlistCourseId) {
    const index = state.userPlaylistDefault
      .playlist_courses
      .findIndex(i => i.id == playlistCourseId)

    state.userPlaylistDefault.playlist_courses.splice(index, 1)
  }
}

const actions = {
  async createUserPlaylistDefaultCourse (context, courseId) {
    const response = await createUserPlaylistDefaultCourse('me', courseId)
    state.userPlaylistDefault = response.playlist
  },

  async fetchUserPlaylistDefault ({ state }) {
    const playlist = await getUserPlaylistDefault('me')
    state.userPlaylistDefault = playlist
  },

  async removeUserPlaylistDefaultCourse ({ commit }, playlistCourseId) {
    await deleteUserPlaylistDefaultCourse('me', playlistCourseId)
    commit('removeUserPlaylistDefaultCourse', playlistCourseId)
  },
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
